/**
 * Runs first among client plugins. Patches document.createElement so any <style>
 * or <script> created by the bundle or third-party code (e.g. vue-style-loader,
 * GTM, vue-gtag) gets the CSP nonce before content is appended, avoiding CSP violations.
 * Must run before any chunk that injects styles or scripts.
 */

if (typeof document !== 'undefined' && !document.createElement.__cspNoncePatched) {
  const original = document.createElement.bind(document)
  document.createElement = function (tagName) {
    const el = original(tagName)
    if (tagName && (String(tagName).toLowerCase() === 'style' || String(tagName).toLowerCase() === 'script')) {
      const meta = document.querySelector('meta[name="csp-nonce"]')
      const nonce = meta ? meta.getAttribute('content') : null
      if (nonce) el.setAttribute('nonce', nonce)
    }
    return el
  }
  document.createElement.__cspNoncePatched = true
}
